import { jsxs as h, jsx as r } from "@emotion/react/jsx-runtime";
import { useState as s, useRef as p, useEffect as j } from "react";
import { CarouselContainer as z, SlideContainer as A, Slide as y, Image as B, DotEmptyContent as v, ContentContainer as F, Controls as G, DotsContainer as P, Dot as U } from "./Carousel.styled.js";
import { IconButton as H } from "../IconButton/index.js";
import { FontAwesomeIconsPartooUsed as I } from "../../types/components/icon.js";
const O = ({
  dataTrackId: l,
  slides: n,
  showControls: w = !0,
  dotPosition: i = "image",
  maxHeightImage: x = 300
}) => {
  const [o, m] = s(0), [$, b] = s(!0), [S, L] = s([]), [k, D] = s([]), u = p([]), f = p([]), C = (t) => {
    if (!n || n.length === 0) return;
    const R = t === "prev" ? o === 0 ? n.length - 1 : o - 1 : (o + 1) % n.length;
    m(R);
  }, c = () => {
    const t = f.current.map((a) => a?.offsetHeight ?? 0), e = u.current.map((a) => a?.offsetHeight ?? 0);
    D(t), L(e), b(!1);
  }, E = (t) => {
    m(t);
  };
  j(() => (c(), window.addEventListener("resize", c), () => {
    window.removeEventListener("resize", c);
  }), [n]);
  const g = k[o] ?? 0, N = S[o] ?? 0, d = g + N + (n[o].content ? 32 : 0);
  return /* @__PURE__ */ h(z, { "data-track": l, "aria-label": "Carousel", children: [
    /* @__PURE__ */ r(A, { currentIndex: o, "aria-live": "polite", children: n.map((t, e) => /* @__PURE__ */ h(y, { role: "group", "aria-roledescription": "slide", "aria-label": `Slide ${e + 1} of ${n.length}`, height: d, dotPosition: i, children: [
      t.image && /* @__PURE__ */ r(B, { ref: (a) => {
        f.current[e] = a;
      }, src: t.image, alt: `Slide ${e + 1}`, onLoad: c, maxHeightImage: x }),
      i === "between" && /* @__PURE__ */ r(v, {}),
      !$ && t.content && /* @__PURE__ */ r(F, { ref: (a) => {
        u.current[e] = a;
      }, children: t.content }),
      i === "bottom" && /* @__PURE__ */ r(v, {})
    ] }, `${l}-slide-${e}`)) }),
    w && /* @__PURE__ */ h(G, { imageHeight: g, children: [
      /* @__PURE__ */ r(H, { dataTrackId: "carousel-prev", icon: [I.faChevronLeft], onClick: () => C("prev"), "aria-label": "Previous Slide", "aria-controls": "carousel-slides", variant: "theme" }),
      /* @__PURE__ */ r(H, { dataTrackId: "carousel-next", onClick: () => C("next"), icon: [I.faChevronRight], "aria-label": "Next Slide", "aria-controls": "carousel-slides", variant: "theme" })
    ] }),
    /* @__PURE__ */ r(P, { dotPosition: i, imageHeight: g, slideHeight: d, children: n.map((t, e) => /* @__PURE__ */ r(U, { isActive: o === e, onClick: () => E(e), "aria-label": `Go to slide ${e + 1}` }, `${l}-dots-${e}`)) })
  ] });
};
export {
  O as Carousel
};
